import React, { useState, useEffect } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { MdDeleteOutline } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import "../Tables/Table.css";

function ReminderHistory({ isSidebarExpanded }) {
  const [Firms, setFirms] = useState([]); // Store firm data
  const [loading, setLoading] = useState(false); // Handle loading state
  const [clientName, setClientName] = useState(""); // State for client name

  const navigate = useNavigate();
  const location = useLocation();
  const { invoice_id } = useParams(); // Access the invoice_id parameter
  const isFamilyHistory = location.state?.historyType === "family_group";
  const familyId = location.state?.family_id || invoice_id;

  const formatDisplayDate = (value) => {
    if (!value) return "NA";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "NA";
    return d.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Fetch data function
  const fetchData = async () => {
    try {
      setLoading(true);

      const endpoint = isFamilyHistory
        ? `/api/get_family_reminder_log/${familyId}`
        : `/api/get_all_reminder_log/${invoice_id}`;

      const response = await axiosInstance.get(endpoint);

      setFirms(response.data?.data || []);

      if (isFamilyHistory) {
        setClientName(
          response.data?.family_group_name ||
            location.state?.family_group_name ||
            ""
        );
      } else if (response.data?.client_name) {
        setClientName(response.data.client_name);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching firm data:", error.message);
      setLoading(false);
    }
  };

  // Call fetchData when component mounts
  useEffect(() => {
    if (invoice_id || familyId) {
      fetchData();
    }
  }, [invoice_id, familyId, isFamilyHistory]);

  // Handle delete function
  const handleDelete = async (reminder_id) => {
    try {
      const response = await axiosInstance.post(
        `/api/delete_reminder_log/${reminder_id}`,
        {}
      );

      if (response.status === 200) {
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting reminder:", error.message);
      alert("Failed to delete reminder. Please try again.");
    }
  };

  return (
    <div
      className={`table-container reminder-history-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body">
        <div className="table-container reminder-history-page-inner">
          <div className="table-header">
            <div className="table-header-content">
              <div className="table-left-side">
                <div
                  onClick={() => navigate(-1)} // Navigate back to the previous page
                  className="back-button"
                >
                  <IoIosArrowRoundBack />
                </div>
                <h2 className="jost-bold">
                  {`${clientName} - Reminder History`}
                </h2>
              </div>
              <div className="table-right-side"></div>
            </div>
          </div>

          <div className="ledger-data-list-body">
            <div className="ledger-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loading-spinner reminder-history-empty">
                    Loading...
                  </div>
                ) : (
                  <table className="table multilevel-data client-management-table reminder-history-table">
                    <thead>
                      <tr className="table-row">
                        <th>Se. No</th>
                        <th>CLIENT REPLY</th>
                        <th>RECORD DATE</th>
                        <th>NEXT DUE DATE</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {Firms.length > 0 ? (
                        Firms.map((firm, index) => (
                          <tr key={index} className="hoverable-row">
                            <td className="center-align">
                              {firm.serial_number || index + 1}
                            </td>

                            <td className="center-align">
                              {firm.client_reply}
                            </td>
                            <td className="center-align">
                              {formatDisplayDate(firm.record_data)}
                            </td>

                            <td className="center-align">
                              {formatDisplayDate(firm.next_reminder_date)}
                            </td>
                            <td className="center-align">
                              <div
                                className="action-btn"
                                onClick={() => handleDelete(firm.remider_id)} // Call handleDelete on click
                              >
                                <span className="action-icon">
                                  <MdDeleteOutline />
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="center-align reminder-history-empty"
                          >
                            No reminders available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderHistory;
